var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 12,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rewards"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -160,
    y: -628,
    width: 390,
    height: 844,
    rx: 44,
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Content layout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content layout_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reward section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reward card 2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -140,
    y: -38,
    width: 350,
    height: 152,
    rx: 32,
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -139.5,
    y: -37.5,
    width: 349,
    height: 151,
    rx: 31.5,
    stroke: "white",
    strokeOpacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left column"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -14,
    width: 202,
    height: 40,
    rx: 12,
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: -13.5,
    width: 201,
    height: 39,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Title layout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -6,
    width: 24,
    height: 24,
    rx: 10,
    fill: "#D1FE17",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    y: -5.5,
    width: 23,
    height: 23,
    rx: 9.5,
    stroke: "#D1FE17",
    strokeOpacity: 0.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Label",
    d: "M4.0214 11.4545C3.82841 11.4545 3.67196 11.2981 3.67196 11.1051V0.894843C3.67196 0.701857 3.82841 0.54541 4.0214 0.54541C4.21438 0.54541 4.37083 0.701856 4.37083 0.894842V11.1051C4.37083 11.2981 4.21438 11.4545 4.0214 11.4545ZM6.44966 3.92893C6.11272 3.92893 5.85037 3.65829 5.67152 3.37274C5.57883 3.22475 5.4535 3.09765 5.29554 2.99143C4.966 2.767 4.55123 2.65479 4.05123 2.65479C3.69327 2.65479 3.38361 2.7116 3.12225 2.82524C2.86088 2.93604 2.65776 3.08944 2.51287 3.28547C2.37083 3.47865 2.2998 3.69882 2.2998 3.94598C2.2998 4.15337 2.3481 4.33234 2.44469 4.48291C2.54412 4.63348 2.67338 4.7599 2.83248 4.86217C2.99441 4.9616 3.1677 5.04541 3.35236 5.11359C3.53702 5.17893 3.71458 5.23291 3.88503 5.27552L4.7373 5.49712C5.01571 5.5653 5.30122 5.65763 5.59384 5.7741C5.88645 5.89058 6.15776 6.04399 6.40776 6.23433C6.65776 6.42467 6.85946 6.66047 7.01287 6.94172C7.16912 7.22297 7.24725 7.55962 7.24725 7.95166C7.24725 8.44598 7.11941 8.8849 6.86373 9.26842C6.61088 9.65195 6.24299 9.9545 5.76003 10.1761C5.27992 10.3977 4.69895 10.5085 4.01713 10.5085C3.36373 10.5085 2.79838 10.4048 2.32111 10.1974C1.84384 9.99001 1.47026 9.69598 1.20037 9.3153C1.05714 9.11175 0.947913 8.88821 0.872694 8.64466C0.759656 8.27865 1.0749 7.95166 1.45796 7.95166C1.80593 7.95166 2.07349 8.23499 2.24197 8.53945C2.28151 8.61092 2.32778 8.67777 2.38077 8.74001C2.56259 8.9474 2.79412 9.10223 3.07537 9.2045C3.35946 9.30393 3.67054 9.35365 4.00861 9.35365C4.38077 9.35365 4.71174 9.29541 5.00151 9.17893C5.29412 9.05962 5.52424 8.89484 5.69185 8.68462C5.85946 8.47155 5.94327 8.22297 5.94327 7.93888C5.94327 7.68035 5.86941 7.46871 5.72168 7.30393C5.57679 7.13916 5.37935 7.0028 5.12935 6.89484C4.88219 6.78689 4.60236 6.69172 4.28986 6.60933L3.25861 6.32808C2.55975 6.13774 2.00577 5.85791 1.59668 5.48859C1.19043 5.11927 0.987305 4.63064 0.987305 4.02268C0.987305 3.51984 1.12367 3.08092 1.3964 2.70592C1.66912 2.33092 2.03844 2.03973 2.50435 1.83234C2.97026 1.62212 3.49583 1.517 4.08105 1.517C4.67196 1.517 5.19327 1.62069 5.64498 1.82808C6.09952 2.03547 6.45748 2.32098 6.71884 2.68461C6.84872 2.86391 6.94773 3.05653 7.01588 3.26249C7.13271 3.61557 6.82157 3.92893 6.44966 3.92893Z",
    fill: "#D1FE17"
  }))))))))))), /*#__PURE__*/React.createElement("rect", {
    x: -160.5,
    y: -628.5,
    width: 391,
    height: 845,
    rx: 44.5,
    stroke: "#0D0D0D",
    strokeOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -160,
    y: -628,
    width: 390,
    height: 844,
    rx: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon_dollar.de51dd83cf1b4ff9bb272988cc5eedb3.svg";
export { ForwardRef as ReactComponent };